import Carousel from "utils/carousel/carousel"

export default function init() {
  const targets = document.querySelectorAll("[data-carousel]")
  const badges = document.querySelectorAll("[data-badge-carousel]")

  const carousels = [...targets].map((x) => new Carousel(x).init())
  const carouselBadges = [...badges].map((x) =>
    new Carousel(x, { dots: false, buttons: false }).init(),
  )

  return carousels.concat(carouselBadges)
}
